export default () => ({
  select: {
    width: '100%',
  },
});
